import { Component, AfterViewInit, HostListener } from '@angular/core';
import { createChart, LineData, BarData, LineType } from 'lightweight-charts';
import * as moment from 'moment';
import { Chart } from '../Models/Chart';
import { DrawingService } from '../Services/DrawingService';
import { ThrowStmt } from '@angular/compiler';
import { ResizeService } from '../Services/ResizeService.service';
import { TimeoutError } from 'rxjs';
import { TrackedStrikesService } from '../Services/TrackedStrikes/TrackedStrikes.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements AfterViewInit {

  private chart: Chart;

  private _canShow: boolean = false;
  public get canShow(): boolean {
    return this._canShow;
  }
  public set canShow(value: boolean) {
    this._canShow = value;

    if(value==true)
    {
      this._TrackedStrikesService.getAllTrackedStrikes();
    }

  }

  constructor(public drawer: DrawingService, public resizeService: ResizeService, public _TrackedStrikesService:TrackedStrikesService) { 

    this.drawer.canShowEvents.subscribe((k)=>{
      this.canShow = this.drawer.settingsService.showEvents;
    })

    this.drawer.settingsService.showEventsSignal.subscribe((k)=>{
      this.canShow = this.drawer.settingsService.showEvents;
    })
  }

  ngAfterViewInit(): void {

    const chartTarget = document.getElementById('chartWrapper');
    //const plotTarget = document.getElementById('chartWrapperSma');


    this.drawer.drawingTarget = chartTarget;
    //this.drawer.drawingOscillatorTarget = plotTarget;
    this.drawer.init();

  }
  private thortler: NodeJS.Timeout;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // event.target.innerWidth;
    // event.target.innerHeight;
    // //console.log("REISZED");
    // this.thortler = setTimeout(v=>{
    //   this.resizeService.resizeAction(event.target.innerWidth-10, event.target.innerHeight-10);
    // },500)

    let diff = (this.drawer.dataService.systemVersion=="iOS")?60:20;
    if (this.thortler) {
      clearTimeout(this.thortler);
    };

    this.thortler = setTimeout(() => {
      this.resizeService.resizeAction(event.target.innerWidth-10, event.target.innerHeight - diff);
    }, 500);

  }

  public targetStyle()
  {
    let diff = (this.drawer.dataService.systemVersion=="iOS")?'calc( 100% - 40px )':'calc( 100% - 20px )';

    return {
     width:"calc( 100% - 0px )",
     height:diff,
     minHeight:"400px",
     zIndex:1
    }
  }
}
